import axios from 'axios'
import { trackPromise } from 'react-promise-tracker';
import * as CommonVariables from '../../Common/CommonVariables'

export const GetActivePartnerList = async () => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Notification/GetActivePartnerList`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetActiveNotificationList = async () => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Notification/GetActiveNotificationList`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const CreateNotification = async (notificationDet) => {
    var result = await trackPromise(
        axios.post(CommonVariables.API_DOMAIN + `Notification/CreateNotification`, 
        JSON.stringify(notificationDet), 
        CommonVariables.API_HEADER)
        ).then(response => response);
    return result;
}

export const UpdateNotification = async (notificationDet) => {
    var result = await trackPromise(
        axios.post(CommonVariables.API_DOMAIN + `Notification/UpdateNotification`, 
        JSON.stringify(notificationDet), 
        CommonVariables.API_HEADER)
        ).then(response => response);
    return result;
}

export const AddNewDocument = async (documentDet) => {
    var result = await trackPromise(
        axios.post(CommonVariables.API_DOMAIN + `Notification/AddNewDocument`, 
        documentDet
        )).then(response => response);
    return result;
}